import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { TranslationObject } from 'src/app/helper/TranslationObject';

@Component({
  selector: 'app-set-dispo-money-popover',
  templateUrl: './set-dispo-money-popover.page.html',
  styleUrls: ['./set-dispo-money-popover.page.scss'],
})
export class SetDispoMoneyPopoverPage implements OnInit {

  timePerApplicant: number;
  moneyPerDispo: number;
  translationObject: any;

  constructor(
    private popoverCtrl: PopoverController
  ) { 
    this.translationObject = TranslationObject.TRANSLATION_OBJECT;
  }

  ngOnInit() {
  }

  saveSettings() {
    this.popoverCtrl.dismiss({
      timePerApplicant: this.timePerApplicant,
      moneyPerDispo: this.moneyPerDispo
    });
  }

}
